export default __webpack_public_path__ + "static/media/14t.a525288e.jpg";